import axios from 'axios';
import { dsaLmsToken } from '../utils/constants/api.constants';
import interceptor from '../services/interceptor';
const api = axios.create();

api.interceptors.request.use(function (config) {
  config.headers['Authorization'] = `Bearer ${dsaLmsToken}`;

  const country = localStorage.getItem('country');
  const vehicleType = localStorage.getItem('vehicleType');

  if (country) config.headers['X_COUNTRY'] = localStorage.getItem('country');
  if (vehicleType)
    config.headers['X_VEHICLE_TYPE'] = localStorage.getItem('vehicleType');
  return config;
});

api.interceptors.response.use(function (response) {
  let parsedResponse = response;

  if (response.config.parse) {
    try {
      parsedResponse = interceptor(response);
    } catch (error) {
      console.info('Parse Error: ', error);
    }
  }
  return parsedResponse;
});

export default api;

const FILE_VERSION = process.env.REACT_APP_FILE_VERSION;
